/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PublishsetTagEditRequest } from '../types/PublishsetTagEdit';
import type { PublishsetTagEditResponse } from '../types/PublishsetTagEdit';

export type PublishsetTagsCreateRequest = PublishsetTagEditRequest;
export type PublishsetTagsCreateResponse = PublishsetTagEditResponse;

export type PublishsetTagsCreateQuery = {};

/**
 * POST /dmx-server/publishset_tags/
 *
 * ```yaml
 * operationId: publishset_tags_create
 * tags:
 *   - publishset_tags
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTagEdit'
 *     description: ''
 * ```
 */
export const publishsetTagsCreateOperation = (rest?: PublishsetTagsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/publishset_tags/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/publishset_tags/' };
  };

/**
 * POST /dmx-server/publishset_tags/
 *
 * ```yaml
 * operationId: publishset_tags_create
 * tags:
 *   - publishset_tags
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetTagEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetTagEdit'
 *     description: ''
 * ```
 */
export const publishsetTagsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PublishsetTagsCreateQuery;
  request: PublishsetTagEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetTagEditResponse>> => {
  const operation = publishsetTagsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
